import { render, staticRenderFns } from "./MyReply.vue?vue&type=template&id=48982462&"
import script from "./MyReply.vue?vue&type=script&lang=js&"
export * from "./MyReply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/views/MyReply.vue"
export default component.exports